import React from "react";
import PropTypes from "prop-types";
// Limitless imports
import CodeCollector from "@limitless/modern/inputs/code-collector/CodeCollector";
import Typography from "@limitless/modern/data-display/typography/Typography";
import Grid from "@limitless/modern/layout/Grid";
import { useMFASetupContext } from "../../../../../hooks/mfa-setup/MFASetupContext";
import Button from "@limitless/modern/inputs/button/Button";
import { useExpertProfileContext } from "../../../../../../expert";
import { MFA_INVALID_CODE_PROVIDED } from "../../../../..";
const MfaVerificationCodeInput = ({
  mfaState,
  successCB,
  setMfaState
}) => {
  const {
    verifyMFAState,
    maxLength,
    clearCodes,
    verifyButtonHandler,
    updateCodeCollector,
    updateEmailCodeCollector,
    clearCode,
    validateMfaSMS,
    validateMfaEmail
  } = useMFASetupContext();
  const {
    profile
  } = useExpertProfileContext();
  const disableVerificationBtn = React.useMemo(() => !verifyMFAState.btnVisible || verifyMFAState.freezeVerification, [verifyMFAState.freezeVerification, verifyMFAState.btnVisible]);
  const showErrMsg = React.useMemo(() => !verifyMFAState.loading && (verifyMFAState.errTxt || verifyMFAState.verifyFailed), [verifyMFAState]);
  const maxCodeLength = React.useMemo(() => {
    return !mfaState.isEmailVerifyed ? 4 : maxLength;
  }, [mfaState]);
  const handleResendClick = () => {
    clearCode();
    !mfaState.isEmailVerifyed ? validateMfaEmail(null, mfaState) : validateMfaSMS(mfaState, updatedState => {});
  };
  const renderButtonText = text => /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    onClick: handleResendClick,
    sx: {
      cursor: "pointer",
      paddingLeft: theme => theme.spacing(0.3)
    },
    color: "primary"
  }, text);
  const verifyNumberButtonHandler = async () => {
    await verifyButtonHandler({
      type: mfaState.mfaType,
      notificationHeader: "Update Security",
      primaryContactNumber: mfaState.phoneNumber,
      mfaState
    }, successCB);
  };
  const verifyEmailButtonHandler = () => {
    validateMfaEmail(verifyMFAState.code, mfaState, updateState => setMfaState(updateState));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8,
    display: "flex",
    flexDirection: "column"
  }, mfaState.isEmailVerifyed && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.grey[4]
    }
  }, "Your phone number has now been updated successfully."), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.grey[4],
      fontWeight: "bold"
    },
    pt: 1,
    pb: 1
  }, "You must verify your new phone number to continue")), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.grey[4]
    },
    translationSubstitutes: !mfaState.isEmailVerifyed ? profile.email : mfaState.phoneNumber
  }, "A verification code has been sent to {0}."), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.grey[4]
    }
  }, "Please enter your code below:"))), /*#__PURE__*/React.createElement(Grid, {
    mt: theme => theme.spacing(1.5),
    mb: theme => theme.spacing(1.5)
  }, /*#__PURE__*/React.createElement(CodeCollector, {
    clearAll: clearCodes,
    max: maxCodeLength,
    onUpdate: !mfaState.isEmailVerifyed ? updateEmailCodeCollector : updateCodeCollector
  })), /*#__PURE__*/React.createElement(Grid, {
    mt: theme => theme.spacing(0.7)
  }, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    variant: "contained",
    onClick: !mfaState.isEmailVerifyed ? verifyEmailButtonHandler : verifyNumberButtonHandler,
    disabled: disableVerificationBtn || verifyMFAState.loading,
    id: "mfaCodeVerificationButton"
  }, "Verify")), /*#__PURE__*/React.createElement(Grid, {
    mt: theme => theme.spacing(1.5),
    container: true,
    direct: "row",
    alignItems: "center"
  }, showErrMsg && verifyMFAState.errTxt === MFA_INVALID_CODE_PROVIDED ? /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.error.dark
    }
  }, verifyMFAState.errTxt, " ", "or", renderButtonText("send a new code")) : showErrMsg ? /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.error.dark
    }
  }, verifyMFAState.errTxt && verifyMFAState.errTxt) : /*#__PURE__*/React.createElement(Grid, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Grid, {
    display: "flex",
    flexDirection: "row"
  }, mfaState.errTxt.includes("OTP Expired") ? renderButtonText("send a new code") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, "Didn't get the code?"), renderButtonText("Resend"))), mfaState.errTxt && /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.error.dark
    }
  }, mfaState.errTxt))));
};
export default MfaVerificationCodeInput;
MfaVerificationCodeInput.propTypes = {
  mfaState: PropTypes.object,
  successCB: PropTypes.func,
  setMfaState: PropTypes.func
};